import lightGallery from 'lightgallery';
import lgZoom from 'lightgallery/plugins/zoom';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'lightgallery/css/lg-zoom.css';
import lgVideo from 'lightgallery/plugins/video';


document.addEventListener('DOMContentLoaded', function () {
    lightGallery(document.getElementById("gallery-container"), {
        speed: 500,
        plugins: [lgZoom, lgVideo],
    });

    lightGallery(document.getElementById('gallery-videojs-demo'), {
        plugins: [lgVideo],
        videojs: true,
        videojsOptions: {
            muted: true,
        },
    });
});


